import InvoiceGeneratorTemplate from './templates/InvoiceGeneratorTemplate';
import { INVOICE_GENERATOR_CONFIG } from './config/invoiceGenerator';

export default function InvoiceGeneratorDE() {
  return <InvoiceGeneratorTemplate cfg={INVOICE_GENERATOR_CONFIG.DE} />;
}
